/** Supported BRD / brief uploads (multipart to /api/chat/document). */
export const DOCUMENT_UPLOAD_EXTENSIONS = [".docx", ".txt", ".pdf"];

export const DOCUMENT_UPLOAD_ACCEPT =
  ".docx,.txt,.pdf,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain";

export const DOCUMENT_UPLOAD_ERROR_MESSAGE =
  "Please upload a .docx, .txt, or .pdf file.";

export const MAX_DOCUMENT_UPLOAD_MB = 100;
export const MAX_DOCUMENT_UPLOAD_BYTES = MAX_DOCUMENT_UPLOAD_MB * 1024 * 1024;

export function getDocumentFileExtension(fileName) {
  const lower = String(fileName || "").toLowerCase();
  if (lower.endsWith(".docx")) return "docx";
  if (lower.endsWith(".pdf")) return "pdf";
  if (lower.endsWith(".txt")) return "txt";
  return null;
}

export function isLegacyDocFile(fileName) {
  const lower = String(fileName || "").toLowerCase();
  return lower.endsWith(".doc") && !lower.endsWith(".docx");
}

export function isSupportedDocumentUpload(file) {
  return Boolean(getDocumentFileExtension(file?.name));
}

export function getDocumentTypeLabel(fileName) {
  const ext = getDocumentFileExtension(fileName);
  if (ext === "pdf") return "PDF";
  if (ext === "docx") return "Word document";
  if (ext === "txt") return "Text file";
  return "Document";
}

function mimeTypeForDocument(fileName) {
  const ext = getDocumentFileExtension(fileName);
  if (ext === "pdf") return "application/pdf";
  if (ext === "docx") {
    return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  }
  if (ext === "txt") return "text/plain";
  return "application/octet-stream";
}

/** Ensure multipart uploads send a useful Content-Type when the browser omits file.type. */
export function prepareDocumentUploadFile(file) {
  if (!file || !(file instanceof Blob)) {
    throw new Error("A file is required for document upload");
  }
  const fileName = file.name || "upload";
  if (!isSupportedDocumentUpload({ name: fileName })) {
    throw new Error(DOCUMENT_UPLOAD_ERROR_MESSAGE);
  }
  const expectedType = mimeTypeForDocument(fileName);
  if (file.type === expectedType) {
    return file;
  }
  return new File([file], fileName, { type: expectedType });
}
